import { roleAccessCoverageSummary } from '../constants/userRoleDisplay';
import styles from './RoleAccessCoverageCell.module.css';

export function RoleAccessCoverageCell({ packs }: { packs: readonly string[] }) {
  const summary = roleAccessCoverageSummary(packs);
  const fill = Math.max(0, Math.min(100, summary.percent));
  return (
    <span
      className={`${styles.cell} ${styles[`band_${summary.band}`]}`}
      title={summary.ariaLabel}
      aria-label={summary.ariaLabel}
    >
      <span className={styles.battery} aria-hidden>
        <span className={styles.batteryBody}>
          <span className={styles.batteryFill} style={{ width: `${fill}%` }} />
        </span>
        <span className={styles.batteryCap} />
      </span>
      <span className={styles.percent}>{summary.percent}%</span>
      <span className={styles.level}>{summary.levelLabelFr}</span>
    </span>
  );
}
